<neptune-sidenav
  state="rail"
  show-menu
  position="left"
  #neptuneSidenav
  (neptune-sidenav-navigate)="onNavigate($event)"
></neptune-sidenav>
